import './helpers-d639255d.js';
import { b as registerComponent, u as use } from './plugins-4295ce0e.js';
import './Icon-9c764942.js';
import './FormElementMixin-f9847bcc.js';
import { _ as __vue_component__ } from './Input-69be569b.js';
export { _ as OInput } from './Input-69be569b.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, __vue_component__);
  }
};
use(Plugin);

export default Plugin;
